import { LoyaltyActionFeature } from '../../types/loyaltyAction';

export const LOYALTY_ACTION_FEATURES = [
  {
    text: 'Sign up for notifications',
    value: LoyaltyActionFeature.ENABLE_NOTIFICATIONS,
  },
  {
    text: 'Complete WITB',
    value: LoyaltyActionFeature.COMPLETE_WITB,
  },
  {
    text: 'Sync USGA account',
    value: LoyaltyActionFeature.SYNC_USGA,
  },
  {
    text: 'Track a round',
    value: LoyaltyActionFeature.TRACK_ROUND,
  },
  {
    text: 'Complete quiz',
    value: LoyaltyActionFeature.COMPLETE_QUIZ,
  },
  {
    text: 'Register Your Clubs',
    value: LoyaltyActionFeature.REGISTER_YOUR_CLUB,
  },
  {
    text: 'Birthday Gift',
    value: LoyaltyActionFeature.BIRTHDAY_GIFT,
  },
  {
    text: 'Trade-In Clubs',
    value: LoyaltyActionFeature.TRADE_IN_CLUB,
  },
  {
    text: 'Signup Newsletter',
    value: LoyaltyActionFeature.SIGNUP_NEWSLETTER,
  },
];
